export const messages = {
  en: {
    urgentPurchaseApplyStep: {
      applyInfo: 'Application Information',
      warehouse: 'Warehouse',
      requiredSelectWarehouse: 'Required, please select warehouse',
      contact: 'Contact',
      requiredContact: 'Required, please fill in contact',
      phone: 'Phone',
      requiredPhone: 'Required, please fill in phone number',
      applyDesc: 'Application Description',
      requiredDesc: 'Required, please fill in application description',
      purchaseItems: 'Purchase Items',
      select: 'Select',
      itemType: 'Item Type',
      nameCode: 'Name(Code)',
      spec: 'Specification',
      referencePrice: 'Reference Price',
      stock: 'Stock',
      applyQuantity: 'Apply Quantity',
      requiredQuantity: 'Required, please fill in quantity',
      purchasePrice: 'Purchase Price',
      requiredPrice: 'Required, please fill in price',
      targetWarehouse: 'Target Warehouse',
      requiredTargetWarehouse: 'Required, please select target warehouse',
      remark: 'Remark',
      optionalRemark: 'Optional, please fill in remark',
      operation: 'Operation',
      remove: 'Remove',
      submit: 'Submit',
      requiredSelectItems: 'Please select purchase items',
      sameWarehouseRequired: 'Purchased items must come from the same warehouse!'
    },
    chooseResourceStore4: {
      title: '[Urgent Purchase] Select Items',
      selectWarehouse: 'Please select warehouse',
      selectItemType: 'Please select item type',
      selectSubType: 'Please select sub category',
      inputItemName: 'Input item name',
      warehouse: 'Warehouse',
      itemType: 'Item Type',
      itemName: 'Item Name',
      spec: 'Specification',
      code: 'Code',
      fixedItem: 'Fixed Item',
      price: 'Price',
      stock: 'Stock',
      selectItemsRequired: 'Please select items to purchase'
    }
  },
  zh: {
    urgentPurchaseApplyStep: {
      applyInfo: '申请信息',
      warehouse: '仓库',
      requiredSelectWarehouse: '必填，请选择仓库',
      contact: '联系人',
      requiredContact: '必填，请填写联系人',
      phone: '联系电话',
      requiredPhone: '必填，请填写联系电话',
      applyDesc: '申请说明',
      requiredDesc: '必填，请填写申请说明',
      purchaseItems: '采购物品',
      select: '选择',
      itemType: '物品类型',
      nameCode: '名称(编码)',
      spec: '物品规格',
      referencePrice: '参考价格',
      stock: '物品库存',
      applyQuantity: '申请数量',
      requiredQuantity: '必填，请填写申请数量',
      purchasePrice: '采购单价',
      requiredPrice: '必填，请填写采购单价',
      targetWarehouse: '目标仓库',
      requiredTargetWarehouse: '必填，请选择目标仓库',
      remark: '备注',
      optionalRemark: '选填，请填写备注',
      operation: '操作',
      remove: '移除',
      submit: '提交',
      requiredSelectItems: '请选择采购物品',
      sameWarehouseRequired: '采购商品需来自同一仓库！'
    },
    chooseResourceStore4: {
      title: '【紧急采购】选择物品',
      selectWarehouse: '请选择仓库',
      selectItemType: '请选择物品类型',
      selectSubType: '请选择二级分类',
      inputItemName: '输入物品管理名称',
      warehouse: '仓库',
      itemType: '物品类型',
      itemName: '物品名称',
      spec: '物品规格',
      code: '物品编码',
      fixedItem: '固定物品',
      price: '物品价格',
      stock: '物品库存',
      selectItemsRequired: '请选择需要采购的物品'
    }
  }
}